<template>
  <div>
    <h1 class="title is-pulled-left">Contact Notes for {{contact.forename}} {{contact.surname}}</h1>
        <div class="buttons  is-pulled-right">
            <router-link :to="'/contacts/' + contactId + '/addnote'"><button class="button is-success">Add New Note</button></router-link>
        
        </div>


      <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Date</th>
                <th>Added By</th>
                <th>Comments</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr valign="top"  v-for="row in notes" v-cloak v-bind:key="row.id">
                    <td >{{ row.date }}</td>
                    <td>{{row.name}}</td>
                    <td style="white-space: pre;">{{row.comments}}</td>
                    <td>
                      <button class="button is-danger is-small"  @click="deleteNote($event, row.id)">Delete</button>
                    </td>
                </tr>
                
            </tbody>

        </table>
  </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';

  export default {
    props: [
      'notes',
      'contactId',
      'contact',
      'accessToken'
    ],
    data() {
      return {
       
      }
    },
    methods: {
      async deleteNote(event, noteId)
      {
        event.target.disabled = 1;
        
        UtilityService.deleteSimpleApiData(this.accessToken, 'contact_notes/' + noteId).then(
          this.$emit('reloadContact')
        );

        
      }
    }
  }
</script>
